import React from 'react';
import { useHistory } from 'react-router';
import { Button } from '@mui/material';

export default function BackButton() {
  const history = useHistory();
  const handlePushBack = () => {
    history.goBack();
  };
  return (
    <Button
      variant="outlined"
      onClick={handlePushBack}
      className="print-disable"
    >
      กลับ
    </Button>
  );
}
